import React, { useState } from "react";
import Input from "../../../components/ui/Input";
import Button from "../../../components/ui/Button";
import GoogleSignInButton from "./GoogleSignInButton";
import {
  signup,
  validatePasswordClient,
  PASSWORD_HINT,
} from "../../../services/authService";
import {
  trackSignUpComplete,
  trackSignUpStart,
} from "../../../utils/signupTracking";

const SignupForm = ({ onSignupSuccess, onSwitchToLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    trackSignUpStart("email");

    const passwordError = validatePasswordClient(password);
    if (passwordError) {
      setError(passwordError);
      return;
    }
    if (password !== confirmPassword) {
      setError("As senhas não coincidem.");
      return;
    }

    setLoading(true);
    try {
      const result = await signup({ email, password });

      if (result.ok) {
        trackSignUpComplete("email");
        onSignupSuccess?.(result.data?.email || email, password);
        return;
      }

      setError(
        result.data?.message || "Não foi possível criar a conta. Tente novamente."
      );
    } catch {
      setError("Erro de conexão. Verifique sua internet e tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <Input
        label="E-mail"
        type="email"
        required
        autoComplete="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="seu@email.com"
      />
      <Input
        label="Senha"
        type="password"
        required
        autoComplete="new-password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="••••••••"
        description={PASSWORD_HINT}
      />
      <Input
        label="Confirmar senha"
        type="password"
        required
        autoComplete="new-password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        placeholder="••••••••"
      />

      {error && (
        <p className="text-sm text-destructive" role="alert">
          {error}
        </p>
      )}

      <Button type="submit" size="lg" fullWidth loading={loading} disabled={loading}>
        Criar conta
      </Button>

      <GoogleSignInButton />

      <p className="text-center text-sm text-muted-foreground">
        Já tem conta?{" "}
        <button
          type="button"
          className="text-primary font-medium hover:underline"
          onClick={onSwitchToLogin}
        >
          Entrar
        </button>
      </p>
    </form>
  );
};

export default SignupForm;
